import request from '@/utils/request'
import store from '@/store'
const qs = require('qs')

export const getMenu = (url) => {
  return request({
    url: url,
    method: 'get'
  })
}

export const getPrincipal = (url) => {
  return request({
    url: url,
    method: 'get'
  })
}

export const revokeToken = (url) => {
  return request({
    url: url,
    method: 'post',
    data: qs.stringify({ accessToken: store.state.app.accessToken, refreshToken: store.state.app.refreshToken }),
    headers: { 'Content-type': 'application/x-www-form-urlencoded;charset=utf-8' }
  })
}

export async function getConfigItem(url, namespace, key) {
  return await request({
    url: url + '?key=' + key + '&namespace=' + namespace,
    method: 'get',
    data: qs.stringify({ key: key, namespace: namespace })
  })
}
